import { Amplify } from 'aws-amplify';

const userPoolId = import.meta.env.VITE_COGNITO_USER_POOL_ID;
const userPoolClientId = import.meta.env.VITE_COGNITO_CLIENT_ID;
const cognitoDomain = import.meta.env.VITE_COGNITO_DOMAIN; // e.g. "zero-draft-reports.auth.eu-central-1.amazoncognito.com"

if (userPoolId && userPoolClientId) {
  // Cognito callback URLs are registered with a trailing slash
  const currentOrigin = typeof window !== 'undefined' ? window.location.origin + '/' : '';

  // CDK's baseUrl() includes the https:// prefix, but Amplify expects just the hostname.
  const domain = cognitoDomain?.replace(/^https?:\/\//, '');

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId,
        userPoolClientId,
        ...(domain && {
          loginWith: {
            oauth: {
              domain,
              scopes: ['openid', 'email', 'profile'],
              redirectSignIn: [currentOrigin],
              redirectSignOut: [currentOrigin],
              responseType: 'code',
              providers: [{ custom: 'AzureAD' }],
            },
          },
        }),
      },
    },
  });
}

export const isCognitoConfigured = Boolean(userPoolId && userPoolClientId);
export const isSSOConfigured = Boolean(cognitoDomain);
